import { api } from './client';

export const getCategories = () =>
    api.get('/categorias/', { headers: { 'Accept': 'application/json' } });
